export function Uuids(items) {
    return items.map((item) => {
        return item.uuid;
    });
}
